export default __webpack_public_path__ + "static/media/envelope.29317b19.svg";